export default __webpack_public_path__ + "static/media/independentreserve.97a03a15.png";